/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:31:10
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ኽፈት",
    name2: "ቦታ ኣትሕዝ",
    name3: "ብ Carlcare፣ ትእዛዝካ ኣብ ዝኾነ እን ምርግጋፅ ትኽእል ኢኻ",
    name4: "",
    name5: "ናብ የማን ኣንሸራትት",
    name6: "ምርግጋፅ ተዛዚሙ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "ናይ መሳርሒ ሞዴል ምረፅ",
    name2: "ዝተሰሓሓተ ገለፃ",
    name3: "ናይ ግልጋሎት መኽዘን ንምምራፅ ንኻእ",
    name4: "ናይ ግልጋሎት መኽዘን፡",
    name5: "ቦታ ዝተትሓዘሉ ግዜ፡",
    name6: "በይዞም ናይ መሳርሒኦም ፀገም ብዝርዝ ይመዝግቡ!",
    name7: "ናይ ዝበፅሐሉ ግዜ ንምምራፅ ንኻእ",
    name8: "በይዘኦም ትኽክለኛ ኣድራሽኦም የእትዉ ስለዝኾነ ክንረኽቦም ንኽእል ኢና",
    name9: "ዝርከቡ ቦታ ናይ ምትሓዝ እዋን ዝስዕቡ እዮም",
    name10: "በይዘኦም ስልኪ ቑፅሮም የእትዉ",
    name11: "ዋጋ",
    name12: "ናይ ዉልቀ ሓበሬታ፡",
    name13: "በይዘኦም ሽሞም የእትዉ",
    name14: "ኣእትዉ",
    name15: "ሰርዝ",
    name16: "ሕራይ",
  },
  shops: {
    name1: "ብዝመረፅካዮ ብራንድ ብምምስራት፣ እቶም ዝስዕቡ መደብራት ከገልግሉኻ እዮም!",
    name2: "ተወሰኽቲ ናይ ሸቐጥ መኽዘናት ኣብ ቐረባ እዋን! ምሳና ይፅንሑ!",
  },
  price: {
    name1: "ብራንድ",
    name2: "ሞዴል",
    name3: "ነገር",
    name4: "ዋጋ",
    name5: "ምሕዝነታዊ መዘኻኸሪ፡",
    name6: "እቶም ዋጋ ንመጣቐሲ እዮም፣ ስለዝኾነ እቲ ትኽክለኛ ዋጋ በቲ ናይ መሳርሒኻ ብልሽት ኹነት ይዉነን",
    name7: "ፍሉይ ምልክት ተዘይሃልዩዎ፣ እቲ ናይ ዋጋ ክፍሊ ናይ ከባቢ ሸርፊ ክፍሊ እዩ",
    name8: "ይቕረታ! ኣብቲ ናይ ሕጂ ክልል ምንም ናይ  ዋጋ ሓበሬታ የለን",
    name11:"ወፃኢታት ጉልበት",
    name12:"ጠቕላላ ዋጋ",
    name13: "5. ወፃኢ ጉልበት \"/\" እንተኾይኑ፣ ወፃኢ ጉልበት ምስቲ ድንኳን ምምኽኻር የድሊ ማለት እዩ፡፡",
    item_main_board: "ዋና ቦርድ",
    item_screen_frame: "ስክሪን (ፍሬም)",
    item_screen_screen_frame: "ካልኣዊ ስክሪን (ፍሬም)",
    item_touch_screen: "ታች ስክሪን",
    item_camera: "ካሜራ",
    item_fixed_focus_camera: "ቀዋሚ ትኹረት ካሜራ",
    item_auto_focus_camera: "አውቶማቲክ ትኹረት ካሜራ",
    item_screen: "ስክሪን",
    item_secondary_screen: "ካልኣይ ስክሪን",
    item_fingerprint_module: "ናይ ኣፃብዕቲ ዓሸራ ሞዱል",
    item_speaker: "መጋዉሒ ድምፂ",
    item_receiver: "ተቐባሊ",
    item_small_board: "ንእሽቶይ ቦርድ",
    item_battery_cover: "ሽፋን ባትሪ",
    item_battery: "ባትሪ",
    item_charger: "ቻርጀር",
    item_usb_cable: "ናይ USB ገመድ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ዳታ የለን",
    name2: "ግልጋሎት መቕረቢ፡",
    name3: "ናይ ግልጋሎት ብራንድ፡",
    name4: "ቴሌፎን፡",
    name5: "ናይ ትእዛዝ በዝሒ፡",
    name6: "ናይ ግልጋሎት ምድብ",
    name7: "ናይ ግልጋሎት ከባቢ፡",
    name8: "ናይ ግልጋሎት ኹነት፡",
    name9: "ናይ ግልጋሎት ቕልጥፍና፡",
    name10: "ናይ ግልጋሎት ፅፈት፡",
    name11: "ናይ ዓሚል ገምጋም",
    name12:"ናብ",
    name13:"ተዓፅዩ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ኽፈት",
    name1: "በይዘኦም እቲ ናይ ምሓዝ ሓበሬታ ስክሪንሹት የልዕሉ ከምኡዉን ናይ ቐዳምነት ግልጋሎት ንምርካብ ከም ቅብሊት የቐምጥዎ",
    name2: "ብዕዉት ኣትዩ",
    name3: "1. ዳታ ኣፅሪ",
    name4: "በይዘኦም ኣብ ስልኮም ዘሎ ጠቓሚ ናይ ዉልቀ ዳታ ኣቐዲሞም መሐለዉታ ይግበሩ",
    name5: "2. እቲ ናይ ሓይሊ ምብራህ መሕለፊ ቃል ንከይሰርሕ ይግበሩ",
    name6: "ቕድሚ ናይ ናይ ግልጋሎት መኽዘን ምኻዶም፣ በይዘኦም፡",
    name7: "ናይ ግልጋሎት መኽዘን፡",
    name8: "ቦታ ዝተትሓዘሉ ግዜ፡",
    name9: "ዝተሰሓሓተ ገለፃ",
    name10: "ናይ መሳርሒ ሞዴል፡",
    name11: "ናይ ትእዛዝ ቑፅሪ፡",
    name12: "ናይ ትእዛዝ ሓበሬታ",
  },
  title: {
    
    name1: "ዝስዕቡ ሃገራት ይድገፉ፡",
    name2: "ሞዴል ምረፅ",
    name3: "ቦታ ምሓዝ",
    name4: "ናይ ግልጋሎት መኽዘን ዝርዝራት",
    name5: "ናይ ግልጋሎት መኽዘን ምረፅ",
  },
  error: {
    
    name1: "ዳታ የለን፡፡ በይዘኦም ነቲ ናይ ፅገና ሓበሬታ የረጋግፁ",
    name2: "ተወሳኺ ሓገዘዝ ደልዩ ድዮም? በይዘኦም ይርከቡና",
    name3: "ይቕረታ! ኣብቲ ናይ ሕጂ ክልል ናይ  Carlcare ምእኸል የለን",
    name4: "በይዘኦም መጀመርታ ናይ ግልጋሎት ማእኸል ይምረፁ",
    name5: "ፈሺሉ",
    name6: "በይዘኦም መጀመርታ ናይ መሳርሒ ሞዴል ይምረፁ",
    name7: "ዝርዝራት",
    name8: "በይዘኦም ድልየቶም ብዝርዝ ይግለፁ",
    name9: "",
  },
  add1:{
    "name0": "ti-rET",
    "name1": "ትእዛዝኩም ተረጋጊፁ ኣሎ፡፡ ምምፃእኹም ብሃንቀውታ ንፅበ።",
    "name2": "ከተማ ምረፅ",
    "name3": "በይዘኦም ስልኪ ቑፅሪ %1$s ኣሃዛት የእትዉ፡፡",
    "name4": "ናይ ሰሙን መዓልቲ ሰዓታት",
    "name5": "ሰኑይ",
    "name6": "ሰሉስ",
    "name7": "ረቡዕ",
    "name8": "ሓሙስ",
    "name9": "ዓርቢ",
    "name10": "ቐዳም",
    "name11": "ሰንበት",
    "name12": "ሃገር ኣእቲኻ ድለ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ኻልኦት",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ናብ ኣንፈት ምቕያር ዝብል ጠውቕ",
    name3:"ነቲ ትእዛዝ ደረጃ ንምሃብ ነቲ Carlcare ዓውደሞያ ኽፈት",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ግልጋሎት ምረፅ",
    name7:"ነፃ ምፅራይ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ትኽክል ዘይኮነ ሓበሬታ",
    "cancelReason1": "ብሰዓቱ ኣይበፅሐን",
    "cancelReason2": "ዝተደገመ ትእዛዝ/ናተይ ትእዛዝ ኣይኮነን",
    "cancelReason3": "ፍሽለት ኣይተደገመን",
    "cancelReason4": "ንፈተነ ጥራይ/ሕተት/ኽስተት/…",
    "cancelReason5": "ዝለዓለ ዋጋ",
    "cancelReason6": "ናይ ኣቕሓ ሕፅረት",
    "cancelReason7": "ምንም ዝተፈለየ ግልጋሎት የለን",
    "cancelReason8": "እቲ መኽዘን ኣዝዩ ርሑቕ",
    "cancelReason9": "እቲ መኽዘን ተዓፅዩ",
    "cancelReason10": "ሕማቕ ግልጋሎት ኣመለኻኽታ",
    "cancelReason11": "ንኻልኦት ብራንዳትምትካእ/ኣዐሪ",
    "cancelReason12": "ነቲ መኽዘን ምርካብ ኣይተኽኣለን",
    "cancelReason13": "ኻሊእ",
    "cancelOrder": "ትእዛዝ ሰርዝ",
    "reason_dialog_title": "በይዘኦም ናይ ዝተሰረዘሉ ምኽንያት ይንገሩና",
    "Cancel": "ይሰርዙ",
    "OK": "ሕራይ",
    "name1": "ናይ መረጋገፂ ኮድ የእትዉ",
    "name2": "ተቐባልነት ዘይብሉ ናይ መረጋገፂ ኮድ",
    "repair_reservation_detail_canceled": "እዚ ትእዛዝ ተሰሪዙ!",
    "purchase_cancel_dialog_content": "ነቲ ትእዛዝ ክትስርዞ ተረጋገፅ ዲኻ?",
    "yes": "እወ",
    "no": "ኣይኮነን"
}
};
